/** Legacy v1 scenario name -> slug under /version-2/scenarios/spaceflight/ */
module.exports = {
  "Lunar Free Return Trajectory": "apollo-11-free-return-trajectory",
  "NASA Dawn Spacecraft Orbit Around Vesta": "dawn-orbit-of-vesta",
  "NASA TESS Spacecraft Orbit": "tess:-earth–moon-orbit",
  "Operational Spacecraft in Orbit Around Mars":
    "operational-spacecraft-at-mars,-2026",
  "Ulysses Spacecraft Orbit": "ulysses:-jupiter-polar-orbit",
  "Juno Ganymede 2021 Flyby": "juno-flyby-of-ganymede,-7-june-2021",
};
